import React from 'react';
import { Mic, Moon, Sun, HelpCircle, Globe } from 'lucide-react';

interface HeaderProps {
  darkMode: boolean;
  onToggleDarkMode: () => void;
  onOpenHelp: () => void;
  language: 'nl' | 'tr';
  onLanguageChange: (lang: 'nl' | 'tr') => void;
}

const languageNames = {
  nl: 'Nederlands',
  tr: 'Türkçe'
};

export function Header({ darkMode, onToggleDarkMode, onOpenHelp, language, onLanguageChange }: HeaderProps) {
  return (
    <header className="flex flex-col md:flex-row items-center justify-between mb-12 space-y-4 md:space-y-0">
      <div className="flex items-center space-x-4">
        <div className="relative group">
          <div className="absolute -inset-1 bg-gradient-to-r from-orange-600 to-orange-400 rounded-full blur opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
          <div className="relative p-4 bg-black rounded-full transform transition-all duration-200 group-hover:scale-110">
            <Mic className="w-8 h-8 text-orange-500" />
          </div>
        </div>
        <div>
          <h1 className="text-3xl font-bold bg-gradient-to-r from-orange-500 to-orange-600 text-transparent bg-clip-text">
            AI Podcast Generator
          </h1>
          <p className="text-orange-500/80">Powered by P3Media Technology</p>
        </div>
      </div>
      
      <div className="flex items-center space-x-3">
        <div className="relative">
          <select
            value={language}
            onChange={(e) => onLanguageChange(e.target.value as 'nl' | 'tr')}
            className={`pl-8 pr-4 py-2 rounded-lg appearance-none cursor-pointer ${
              darkMode 
                ? 'bg-gray-800 text-white border-gray-700' 
                : 'bg-white text-gray-900 border-gray-200'
            } border focus:outline-none focus:ring-2 focus:ring-orange-500`}
          >
            {Object.entries(languageNames).map(([code, name]) => (
              <option key={code} value={code}>{name}</option>
            ))}
          </select>
          <Globe className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-orange-500" />
        </div>
        
        <button
          onClick={onOpenHelp}
          className="p-2 rounded-lg bg-orange-500 text-white hover:bg-orange-600 transition-colors"
          aria-label="Open help"
        >
          <HelpCircle className="w-5 h-5" />
        </button>
        
        <button
          onClick={onToggleDarkMode}
          className="p-2 rounded-lg bg-orange-500 text-white hover:bg-orange-600 transition-colors"
          aria-label={darkMode ? 'Schakel licht modus in' : 'Schakel donker modus in'}
        >
          {darkMode ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
        </button>
      </div>
    </header>
  );
}